
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class FranchiseeOrdersGrid extends Serenity.EntityGrid<FranchiseeOrdersRow, any> {
        protected getColumnsKey() { return FranchiseeOrdersColumns.columnsKey; }
        protected getDialogType() { return FranchiseeOrdersDialog; }
        protected getIdProperty() { return FranchiseeOrdersRow.idProperty; }
        protected getInsertPermission() { return FranchiseeOrdersRow.insertPermission; }
        protected getLocalTextPrefix() { return FranchiseeOrdersRow.localTextPrefix; }
        protected getService() { return FranchiseeOrdersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getItemCssClass(item: Orders.FranchiseeOrdersRow, index: number): string {
            let klass: string = "";
            if (item.EPaymentStatus == RioERP.Web.Enums.PaymentStatus.Pending)
                klass += " pending";

            if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Placed)
                klass += " placed";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Pending)
                klass += " pending";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Processing)
                klass += " processing";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Processed)
                klass += " processed";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Complete)
                klass += " complete";
            else if (item.EOrderStatus == RioERP.Web.Enums.OrderStatus.Cancelled)
                klass += " cancelled";


            return Q.trimToNull(klass);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            if (!Authorization.hasPermission("Administration:Security")) { buttons.splice(1, 3); }


            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: FranchiseeOrdersService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));






            return buttons;
        }
    }
}